import CategoryRow from "./CategoryRow";
import LoadingComponent from "./LoadingComponent";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { fetchCategories, loadingSet } from "../store/actions/categoryActions";
import Swal from "sweetalert2";

export default function PostTable() {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { categories, loading } = useSelector((state) => state.categories);

	useEffect(() => {
		dispatch(fetchCategories())
			.catch((err) => {
				return Swal.fire({
					icon: "error",
					title: "Error",
					text: err,
				});
			})
			.finally(() => {
				dispatch(loadingSet(false));
			});
	}, []);

	const toAddCategoryPage = () => {
		navigate("/categories/new-category");
	};

	return (
		<>
			<div className="d-flex align-items-center justify-content-between">
				<h2 className="mb-3">Categories List</h2>
				<button onClick={toAddCategoryPage} type="button" className="btn btn-dark">
					Create new category
				</button>
			</div>
			<div className="table-responsive">
				{loading && <LoadingComponent />}
				{!loading && (
					<table className="table table-hover">
						<thead>
							<tr className="text-center table-light">
								<th>No</th>
								<th>Name</th>
								<th>Actions</th>
							</tr>
						</thead>
						<tbody>
							{!loading &&
								categories.map((category, index) => (
									<CategoryRow category={category} index={index} key={category.id} />
								))}
						</tbody>
					</table>
				)}
			</div>
		</>
	);
}
